import React, { useState } from "react";
import {
  Arrow,
  Container,
  Form,
  H3,
  H4,
  Line,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { getFormComponent, processFormData } from "../../helpers/formHandlers";
import { requestPassResetCode, requestSetNewPassword } from "../../api/auth";
import {
  emailProps,
  passwordProps,
  verificationCodeProps,
} from "../../helpers/formProps";
import FormSubmissionBttn from "../../Components/Buttons/FormSubmissionBttn";

const formStyle = css`
  padding: 0 4vh 3vh;
  gap: 2.5vh;
  align-items: center;
`;
const h3Style = css`
  font-size: 2.5vh;
  font-weight: 400;
  align-self: center;
`;
const h4Style = css`
  font-size: 1.25vh;
  font-weight: 200;
  margin-bottom: -1vh;
  font-style: italic;
  display: inline;
  width: 35vh;
`;
const arrowCnt = css`
  width: 2vh;
  align-items: center;
`;
const lineStyle = css`
  width: 2vh;
  border-color: white;
  position: absolute;
  border-width: 0 0.5vh 0.5vh 0;
`;
const arrStyle = css`
  padding: 0.5vh;
  position: absolute;
  right: 0;
  border-color: white;
`;

const resetPasswordForm = [
  passwordProps("New password"),
  verificationCodeProps(),
];

const ResetPasswordForm = ({ setFormStep, showToast }) => {
  const [formData, setForm] = useState(resetPasswordForm);
  const [emailForm, setEmail] = useState([emailProps()]);
  const [formStep, setStep] = useState(0);

  const handleResetCode = async (e) => {
    e.preventDefault();

    try {
      const processedData = processFormData([emailForm[0]]);
      if (processedData.errors === true) {
        const firstError = processedData.formErrors[0];
        showToast({
          title: `Input error`,
          text: `${firstError.errors}`,
          type: "Error",
        });
        return;
      }
      await requestPassResetCode(processedData);
      showToast({
        title: "Success",
        text: "A new verification code has been sent to your email.",
        type: "Success",
      });
      setStep(1);
    } catch (error) {
      showToast({
        title: "Unexpected error",
        text: error.message,
        type: "Error",
      });
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    try {
      const processedData = processFormData(formData);
      if (processedData.errors === true) {
        const firstError = processedData.formErrors[0];
        showToast({
          title: `Input error`,
          text: `${firstError.errors}`,
          type: "Error",
        });
        return;
      }
      processedData.email = emailForm[0];
      await requestSetNewPassword(processedData);
      showToast({
        title: "Success",
        text: "A new verification code has been sent to your email.",
        type: "Success",
      });
      setFormStep(0);
    } catch (error) {
      showToast({
        title: "Unexpected error",
        text: error.message,
        type: "Error",
      });
    }
  };

  if (formStep === 0) {
    return (
      <Form $baseStyle={formStyle} onSubmit={(e) => handleResetCode(e)}>
        <H3 $baseStyle={h3Style}>Reset Your Password</H3>
        <H4 $baseStyle={h4Style}>Please enter your email.</H4>
        {emailForm.map((props, index) =>
          getFormComponent({ props, setForm: setEmail, index })
        )}
        <FormSubmissionBttn
          text="Continue"
          icon={
            <Container $baseStyle={arrowCnt}>
              <Line $baseStyle={lineStyle} />
              <Arrow $baseStyle={arrStyle} $direction={"right"} />
            </Container>
          }
        />
      </Form>
    );
  }
  if (formStep === 1) {
    return (
      <Form $baseStyle={formStyle} onSubmit={(e) => handlePasswordReset(e)}>
        <H3 $baseStyle={h3Style}>Reset Your Password</H3>
        {formData.map((props, index) =>
          getFormComponent({ props, setForm, index })
        )}
        <FormSubmissionBttn text="Submit"/>
      </Form>
    );
  }
};

export default ResetPasswordForm;
